import { orgMemberListResponseSchema, type OrgMember } from '@emr/shared';

import { apiRequest } from './client.ts';

export type { OrgMember };

/** `GET /api/orgs/members` — the provider directory: every active member of the caller's own org, as
 * `{ userId, email, role }`. What the scheduling UI's provider picker (`SchedulePage`,
 * `AppointmentFormDialog`) renders as `email (role)` options, and no longer a pasted UUID. See
 * `server/src/orgs/routes.ts`'s own header. */
export async function listOrgMembers(signal?: AbortSignal): Promise<readonly OrgMember[]> {
  const response = await apiRequest(
    '/api/orgs/members',
    orgMemberListResponseSchema,
    signal === undefined ? {} : { signal },
  );
  return response.members;
}
